var _rect, _rect2, _rect3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoCloudDevs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.7393,
    y: 8.25,
    width: 15.0116,
    height: 15.1868,
    rx: 7.50579,
    fill: "url(#paint0_linear_3786_614)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.1191,
    y: 0.75,
    width: 15.0116,
    height: 15.1868,
    rx: 7.50579,
    fill: "url(#paint1_angular_3786_614)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.712402,
    y: 8.25,
    width: 34.0324,
    height: 15.1868,
    rx: 7.59339,
    fill: "url(#paint2_linear_3786_614)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3786_614",
    x1: 34.7508,
    y1: 15.8434,
    x2: 19.7393,
    y2: 15.8434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41C8FF",
    stopOpacity: 0.76
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_3786_614",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.6389 8.25) scale(8.89575 8.99957)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8FCAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BFFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3786_614",
    x1: 0.712402,
    y1: 15.8434,
    x2: 34.7448,
    y2: 15.8434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#377DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B99FC",
    stopOpacity: 0.07
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCloudDevs);
export default __webpack_public_path__ + "static/media/LogoCloudDevs.438ade8c6362dede42e4fa23c045ec67.svg";
export { ForwardRef as ReactComponent };